define('flight-components/mixins/withData',[
  'App'
],

function (App) {
  'use strict';

  /**
   * A flight mixin for interacting with REST services
   * @exports component:withData
   */
  var withData = function withData() {

    /**
     * The default attributes for this component
     * @type {object}
     */
    var defaults = {};
    this.defaultAttrs(defaults);



    this.getJSON = function(url, success, failure) {
      var self = this;
      var _xhr = $.ajax( App.context + url );

      _xhr.done(function(response){
        success.call(self, response);
      });
    };

    this.get = function(url, success, failure) {
      var self = this;
      var _xhr = $.ajax( url );

      _xhr.done(function(response){
        success.call(self, response);
      });
    };


    /**
     * Get a page via XHR
     *
     * @param ev
     * @param {object} data - Contains the caller sourceId and requested page object
     */
    this.getHttpPage = function(url, success, failure) {
      var self = this;
      var _xhr = $.ajax( App.context + url );

      _xhr.done(function(response){
        var payload = {
          status : 'success',
          page : {
            url: url,
            content: response
          }
        };
        success.call(self, payload);
      });

    };


  };
  return withData;
});



